import React from 'react';
import { IconProps } from '.';

const SvgSort = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='m12 4.5 4.5 6h-9l4.5-6Z' />
      <path fill={secondaryColor} d='m12 19.5-4.5-6h9l-4.5 6Z' />
    </svg>
  );
};

export default SvgSort;
